import { render, staticRenderFns } from "./sknMenuDialog.vue?vue&type=template&id=810e3dbc&scoped=true&"
import script from "./sknMenuDialog.vue?vue&type=script&lang=ts&"
export * from "./sknMenuDialog.vue?vue&type=script&lang=ts&"
import style0 from "./sknMenuDialog.vue?vue&type=style&index=0&id=810e3dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e3dbc",
  null
  
)

export default component.exports